const Respondents = function(detailResultService, searchParametersService) {

  const template = `
    <div class="row">
    <div class="alert alert-danger" ng-show="error">
      We could not retrieve respondents at this time.
    </div>
      <div class="main-header respondents-header" ng-show="!error">
        Respondents:
        <span class="respondents-count">
           {{respondents.totalMatchingRecords}}
        </span>
        <button type="button" class="btn btn-xs sol-button respondents-button"
          ng-show="respondents.totalMatchingRecords > 0"
          ng-click="showRespondents= !showRespondents"
        >
          {{ showRespondents == true ? "Hide Respondents": "Show Respondents" }}
        </button>
      </div>
    </div>
    <table ng-show="showRespondents" class="table table-striped">
      <thead>
        <tr>
          <th class="col-md-1">#</th>
          <th class="col-md-4">Name</th>
          <th class="col-md-2">Address</th>
          <th class="col-md-2">City</th>
          <th class="col-md-1">State</th>
          <th class="col-md-1">Zip</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="respondent in respondents.records | orderBy:'summary.respondent_number'">
          <th>{{ respondent.summary.respondent_number }}</th>
          <td>
            <a 
            ng-href="#/search?respondent={{respondent.respondent}}&typeOfDocument=Respondent&autoSearch=true"
            ng-click="searchParametersService.fromQuick()">
              {{ respondent.respondent }}
            </a>
          </td>
          <td>{{ respondent.summary.respondent_address }}</td>
          <td>{{ respondent.summary.respondent_city }}</td>
          <td>{{ respondent.summary.respondent_state }}</td>
          <td>{{ respondent.summary.respondent_zip }}</td>
          <td>{{ vaultDataId }}</td>
        </tr>
      </tbody>
    </table>
  `

  function link($scope){
    $scope.respondents = detailResultService.queryRespondents($scope)
    $scope.searchParametersService = searchParametersService
    $scope.showRespondents = false
  }

  return {
    template: template,
    link: link,
    scope: {
      record: '='
    }
  }
}

Respondents.$inject = [ 'DetailResultService', 'SearchParametersService' ]

export default Respondents
